import BrowserStorage from '@module/browserstorage';
import ActionHelper from '@module/redux-actions';

export const actions = ActionHelper.types([
  'NOTIFICATION_TRANSFER_SET',
  'NOTIFICATION_TRANSFER_CLEAR',

  'NOTIFICATION_PANEL_SET',
  'NOTIFICATION_PANEL_RESET',

  'NOTIFICATION_POPOVER_SET',
  'NOTIFICATION_POPOVER_RESET',

  'NOTIFICATION_FEATURE_DATA_SET',
]);

export default ActionHelper.generate({
  pushTransfer: [actions.NOTIFICATION_TRANSFER_SET, 'details'],
  clearTransfer: [actions.NOTIFICATION_TRANSFER_CLEAR],

  setNotification: [
    actions.NOTIFICATION_PANEL_SET,
    'category',
    'details',
    'params',
    'duration',
  ],
  resetNotification: [actions.NOTIFICATION_PANEL_RESET],

  setPopoverNotification: [
    actions.NOTIFICATION_POPOVER_SET,
    'category',
    'details',
  ],
  resetPopoverNotification: [actions.NOTIFICATION_POPOVER_RESET],

  setFeatureNotification(key, value) {
    return (dispatch, getState) => {
      const { storage, data } = getState().notification.features;
      // Feature already exists?
      if (data[key]) {
        data[key] = {
          ...data[key],
          ...value,
        };
      } else {
        data[key] = value;
      }

      BrowserStorage.setItem(storage.key, data);

      dispatch({
        type: actions.NOTIFICATION_FEATURE_DATA_SET,
        details: data,
      });
    };
  },

  resetFeatureNotification(key) {
    return (dispatch, getState) => {
      const { storage, data } = getState().notification.features;
      // Feature already exists?
      if (data[key]) {
        delete data[key];
      }

      BrowserStorage.setItem(storage.key, data);

      dispatch({
        type: actions.NOTIFICATION_FEATURE_DATA_SET,
        details: data,
      });
    };
  },
});
